/* eslint-disable react/react-in-jsx-scope */
import React from "react";
import classNames from "classnames";

import { Icon } from "@lululemon/ecom-pattern-library-icon";
import { rightLinkArrowIcon } from "@lululemon/ecom-pattern-library-icons";

import { Link } from "@lululemon/ui-library";
import styles from "../../styles/shop-all-size-link.module.scss";

/**
 * A link to shop all sizes for a given product.
 *
 * @param {Object} props - the component props
 * @param {string} props.oosSizeUrl - the URL to shop all sizes (regardless of stock levels)
 * @param {string} props.activeSize - the currently selected size
 * @param {{ navigationState: string }[]} props.breadCrumbs - the breadcrumb navigation
 * @param {string} props.categoryName - the name of the current product's category
 *
 * @returns {React.ReactElement}
 */
export default function ShopAllSizeLink({
  oosSizeUrl,
  activeSize,
  breadCrumbs,
  categoryName
}) {
  const isCategoryLink =
    breadCrumbs?.length &&
    oosSizeUrl === breadCrumbs[breadCrumbs.length - 1]?.navigationState;

  return (
    <Link
      href={oosSizeUrl}
      className={classNames(styles.arrowUnderline, "lll-text-body-2")}
    >
      <>
        {isCategoryLink
          ? `Shop all ${categoryName}`
          : `Shop all size ${activeSize} ${categoryName}`}
        <Icon
          className={classNames(styles.linkIcon, styles.arrowIcon)}
          content={rightLinkArrowIcon}
          aria-hidden="true"
        />
      </>
    </Link>
  );
}
